import React from 'react';
import { cn } from './cn';

export default function Spinner({ className, label = 'Loading…' }) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 py-8', className)} role="status">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-ga-border-subtle border-t-ga-primary" />
      {label && <p className="text-sm text-ga-text-muted">{label}</p>}
    </div>
  );
}
